<template>
    <div class="page-wrapper">
        <page-header :title="$t('privateProfile.editProfile')" />
        <ion-grid>
            <ion-row>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="maritalStatusOptions"
                        :label="$t('options.maritalStatus')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="marital-status"
                        :error="errors['maritalStatus']"
                        :defaultValue="userMaritalStatus"
                        required="true"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="kidsOptions"
                        :label="$t('options.kids')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="kids"
                        :error="errors['kids']"
                        :defaultValue="userKids"
                        required="true"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="purposeOptions"
                        :label="$t('options.purpose')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="purpose"
                        :error="errors['purpose']"
                        :defaultValue="userPurpose"
                        required="true"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="ageOptions"
                        :label="$t('options.age')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="age"
                        :error="errors['age']"
                        :defaultValue="userAge"
                        required="true"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="countryOptions"
                        :label="$t('options.country')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="country"
                        :error="errors['country']"
                        :defaultValue="userCountry"
                        required="true"
                    />
                </ion-col>

                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        v-if="skinColorOptions"
                        :options="skinColorOptions"
                        :label="$t('options.skinColor')"
                        type="skin-color"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        :defaultValue="userSkinColor"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        v-if="eyeColorOptions"
                        :options="eyeColorOptions"
                        :label="$t('options.eyeColor')"
                        type="eye-color"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        :defaultValue="userEyeColor"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        v-if="hairColorOptions"
                        :options="hairColorOptions"
                        :label="$t('options.hairColor')"
                        type="hair-color"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        :defaultValue="userHairColor"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="originCountryOptions"
                        :label="$t('options.originCountry')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="origin-country"
                        :defaultValue="userOriginCountry"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="heightOptions"
                        :label="$t('options.height')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="height"
                        :defaultValue="userHeight"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="weightOptions"
                        :label="$t('options.weight')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="weight"
                        :defaultValue="userWeight"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="educationalLevelOptions"
                        :label="$t('options.educationalLevel')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="educational-level"
                        :defaultValue="userEducationalLevel"
                    />
                </ion-col>
                <ion-col size-xs="6" size-sm="6" size-md="4">
                    <options-selector
                        :options="jobOptions"
                        :label="$t('options.job')"
                        @onChange="handleChange"
                        @onClear="handleClear"
                        type="job"
                        :defaultValue="userJob"
                    />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="12" size-xl="6">
                    <text-box
                        :label="$t('signup.describeYourself')"
                        inputType="text"
                        @onChange="handleDescribeYourselfChange"
                        :error="errors['describeYourself']"
                        :optionId="describeYourselfOptionId"
                        :defaultValue="userDescribeYourself"
                        rows="2"
                    />
                </ion-col>
                <ion-col size="12" size-xl="6">
                    <text-box
                        :label="$t('signup.describeOthers')"
                        inputType="text"
                        @onChange="handleDescribeOthersChange"
                        :error="errors['describeOthers']"
                        :optionId="describeOthersOptionId"
                        :defaultValue="userDescribeOthers"
                        rows="2"
                    />
                </ion-col>
            </ion-row>
            <ion-row v-if="user">
                <ion-col size="12">
                    <female-contact-ways
                        v-if="userGender == 'female'"
                        :label="$t('options.contactWays')"
                        type="contact-ways"
                        :options="contactWaysOptions"
                        @onChange="handleContactWaysChange"
                        :contactWays="userContactWays"
                    />
                    <checkbox-list
                        v-else
                        :label="$t('options.contactWays')"
                        type="contact-ways"
                        :options="contactWaysOptions"
                        @onChange="handleContactWaysChange"
                        :contactWays="userContactWays"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-button @click="updateOptions" shape="round" strong>{{ $t('master.saveChanges') }}</ion-button>
    </div>
</template>

<script>
import AxiosController from '@/controllers/AxiosController'
import { mapGetters } from 'vuex'
import { validateOptions } from '@/utils/validators.js'
import PageHeader from '@/components/PageHeader'
import OptionsSelector from '@/components/OptionsSelector'
import FemaleContactWays from '@/components/FemaleContactWays'
import CheckboxList from '@/components/CheckboxList'
import TextBox from '@/components/TextBox'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'EditProfile',
    components: {
        OptionsSelector,
        FemaleContactWays,
        CheckboxList,
        PageHeader,
        TextBox
    },
    computed: mapGetters(['user']),
    data() {
        return {
            userGender: '',
            countryOptions: [],
            userCountry: '',
            maritalStatusOptions: [],
            userMaritalStatus: '',
            purposeOptions: [],
            userPurpose: '',
            ageOptions: [],
            userAge: '',
            kidsOptions: [],
            userKids: '',
            originCountryOptions: [],
            userOriginCountry: '',
            hairColorOptions: [],
            userHairColor: '',
            eyeColorOptions: [],
            userEyeColor: '',
            skinColorOptions: [],
            userSkinColor: '',
            heightOptions: [],
            userHeight: '',
            weightOptions: [],
            userWeight: '',
            educationalLevelOptions: [],
            userEducationalLevel: '',
            jobOptions: [],
            userJob: '',
            contactWaysOptions: [],
            userContactWays: '',
            selectedOptions: {},
            optionDetails: {},
            describeYourselfOptionId: '',
            describeOthersOptionId: '',
            describeYourself: '',
            describeOthers: '',
            userDescribeYourself: '',
            userDescribeOthers: '',
            errors: [],
            isMobile
        }
    },
    mounted() {
        const params = {
            type: [
                'gender',
                'country',
                'marital-status',
                'purpose',
                'age',
                'kids',
                'describe-yourself',
                'describe-others',
                'origin-country',
                'eye-color',
                'hair-color',
                'skin-color',
                'height',
                'weight',
                'educational-level',
                'job',
                'contact-ways'
            ]
        }
        AxiosController.get('/options', { params }).then(res => {
            this.countryOptions = res.data.filter(option => option.type === 'country')
            this.maritalStatusOptions = res.data.filter(option => option.type === 'marital-status')
            this.kidsOptions = res.data.filter(option => option.type === 'kids')
            this.purposeOptions = res.data.filter(option => option.type === 'purpose')
            this.ageOptions = res.data.filter(option => option.type === 'age')
            this.originCountryOptions = res.data.filter(option => option.type === 'origin-country')
            this.eyeColorOptions = res.data.filter(option => option.type === 'eye-color')
            this.skinColorOptions = res.data.filter(option => option.type === 'skin-color')
            this.hairColorOptions = res.data.filter(option => option.type === 'hair-color')
            this.heightOptions = res.data.filter(option => option.type === 'height')
            this.weightOptions = res.data.filter(option => option.type === 'weight')
            this.educationalLevelOptions = res.data.filter(option => option.type === 'educational-level')
            this.jobOptions = res.data.filter(option => option.type === 'job')
            this.contactWaysOptions = res.data.filter(option => option.type === 'contact-ways')
            this.describeYourselfOptionId = res.data.find(option => option.type === 'describe-yourself').id
            this.describeOthersOptionId = res.data.find(option => option.type === 'describe-others').id

            this.userGender = this.user.options.find(option => option.type === 'gender').value
            this.selectedOptions['gender'] = this.user.options.find(option => option.type === 'gender').id
            this.userCountry = this.user.options.find(option => option.type === 'country').value
            this.selectedOptions['country'] = this.user.options.find(option => option.type === 'country').id
            this.userMaritalStatus = this.user.options.find(option => option.type === 'marital-status')
                ? this.user.options.find(option => option.type === 'marital-status').value
                : null
            this.selectedOptions['marital-status'] = this.userMaritalStatus
                ? this.user.options.find(option => option.type === 'marital-status').id
                : null
            this.userKids = this.user.options.find(option => option.type === 'kids').value
            this.selectedOptions['kids'] = this.user.options.find(option => option.type === 'kids').id
            this.userPurpose = this.user.options.find(option => option.type === 'purpose').value
            this.selectedOptions['purpose'] = this.user.options.find(option => option.type === 'purpose').id
            this.userAge = this.user.options.find(option => option.type === 'age').value
            this.selectedOptions['age'] = this.user.options.find(option => option.type === 'age').id
            this.userOriginCountry = this.user.options.find(option => option.type === 'origin-country')
                ? this.user.options.find(option => option.type === 'origin-country').value
                : null
            this.selectedOptions['origin-country'] = this.userOriginCountry
                ? this.user.options.find(option => option.type === 'origin-country').id
                : null
            this.userEyeColor = this.user.options.find(option => option.type === 'eye-color')
                ? this.user.options.find(option => option.type === 'eye-color').value
                : null
            this.selectedOptions['eye-color'] = this.userEyeColor ? this.user.options.find(option => option.type === 'eye-color').id : null
            this.userHairColor = this.user.options.find(option => option.type === 'hair-color')
                ? this.user.options.find(option => option.type === 'hair-color').value
                : null
            this.selectedOptions['hair-color'] = this.userHairColor
                ? this.user.options.find(option => option.type === 'hair-color').id
                : null
            this.userSkinColor = this.user.options.find(option => option.type === 'skin-color')
                ? this.user.options.find(option => option.type === 'skin-color').value
                : null
            this.selectedOptions['skin-color'] = this.userSkinColor
                ? this.user.options.find(option => option.type === 'skin-color').id
                : null
            this.userHeight = this.user.options.find(option => option.type === 'height')
                ? this.user.options.find(option => option.type === 'height').value
                : null
            this.selectedOptions['height'] = this.userHeight ? this.user.options.find(option => option.type === 'height').id : null
            this.userWeight = this.user.options.find(option => option.type === 'weight')
                ? this.user.options.find(option => option.type === 'weight').value
                : null
            this.selectedOptions['weight'] = this.userWeight ? this.user.options.find(option => option.type === 'weight').id : null
            this.userEducationalLevel = this.user.options.find(option => option.type === 'educational-level')
                ? this.user.options.find(option => option.type === 'educational-level').value
                : null
            this.selectedOptions['educational-level'] = this.userEducationalLevel
                ? this.user.options.find(option => option.type === 'educational-level').id
                : null
            this.userJob = this.user.options.find(option => option.type === 'job')
                ? this.user.options.find(option => option.type === 'job').value
                : null
            this.selectedOptions['job'] = this.userJob ? this.user.options.find(option => option.type === 'job').id : null
            this.userDescribeYourself = this.user.options.find(option => option.type === 'describe-yourself')
                ? this.user.options.find(option => option.type === 'describe-yourself').pivot.details
                : null
            this.optionDetails[this.describeYourselfOptionId] = this.userDescribeYourself ? this.userDescribeYourself : null
            this.userDescribeOthers = this.user.options.find(option => option.type === 'describe-others').pivot.details
            this.optionDetails[this.describeOthersOptionId] = this.userDescribeOthers
            this.userContactWays = this.user.options.filter(option => option.type === 'contact-ways')
            this.userContactWays.forEach(option => (this.selectedOptions[option.type + '-' + option.id] = option.id))
            if (this.userGender == 'female') {
                this.userContactWays.forEach(option => (this.optionDetails[option.id] = option.pivot.details))
            }
        })
    },
    methods: {
        handleChange: function(option) {
            delete this.selectedOptions[option.type]
            this.selectedOptions[option.type] = option.value
        },
        handleClear: function(option) {
            delete this.selectedOptions[option.type]
            this.selectedOptions[option.type] = null
        },
        handleDescribeYourselfChange(value) {
            this.userDescribeYourself = value.data
            this.optionDetails[this.describeYourselfOptionId] = this.userDescribeYourself
        },
        handleDescribeOthersChange(value) {
            this.userDescribeOthers = value.data
            this.optionDetails[this.describeOthersOptionId] = this.userDescribeOthers
        },
        handleContactWaysChange: function(option) {
            if (this.userGender == 'male') {
                const { data, type } = option
                if (data.checked) {
                    this.selectedOptions[type + '-' + data.optionId] = data.optionId
                } else {
                    this.selectedOptions[type + '-' + data.optionId] = null
                }
            } else {
                const { data } = option
                if (data.data.length) {
                    this.optionDetails[data.optionId] = data.data
                } else {
                    this.optionDetails[data.optionId] = null
                }
            }
        },
        updateOptions: function() {
            this.errors = []

            const { error } = validateOptions({
                maritalStatus: this.selectedOptions['marital-status'] || undefined,
                kids: this.selectedOptions['kids'] || undefined,
                purpose: this.selectedOptions['purpose'] || undefined,
                age: this.selectedOptions['age'] || undefined,
                country: this.selectedOptions['country'] || undefined,
                describeYourself: this.userDescribeYourself,
                describeOthers: this.userDescribeOthers
            })
            if (error) {
                error.details.forEach(err => {
                    this.$set(this.errors, err.path[0], err.message)
                })
                return
            }

            const params = {
                options: this.selectedOptions,
                details: this.optionDetails
            }
            AxiosController.post('/auth/add-options', params).then(res => {
                this.$store.dispatch('setUser', res.data).catch(err => console.log(err))
                this.$router.push('/user/me')
            })
        }
    }
}
</script>
